import { DecoratorNode, SerializedLexicalNode } from 'lexical';
import { Box } from '@mui/material';

export type SerializedImageNode = SerializedLexicalNode & {
  type: 'image';
  file: File;
  filename: string;
  version: 1;
};

export class ImageNode extends DecoratorNode<JSX.Element> {
  __file: File;
  __filename: string;

  static getType(): string {
    return 'image';
  }

  static clone(node: ImageNode): ImageNode {
    return new ImageNode(node.__file, node.__filename);
  }

  constructor(file: File, filename: string) {
    super();
    this.__file = file;
    this.__filename = filename;
  }

  createDOM(): HTMLElement {
    const div = document.createElement('div');
    div.style.display = 'block';
    div.style.marginTop = '8px';
    div.style.marginBottom = '8px';
    return div;
  }

  updateDOM(): false {
    return false;
  }

  decorate(): JSX.Element {
    return (
      <Box 
        sx={{
          display: 'block',
          width: '100%',
          textAlign: 'left',
          my: 1
        }}
      >
        <img 
          src={URL.createObjectURL(this.__file)} 
          alt={this.__filename}
          style={{ 
            maxWidth: '200px',
            maxHeight: '200px',
            objectFit: 'contain',
            borderRadius: '4px',
            display: 'block'
          }}
        />
      </Box>
    );
  }

  getFile(): File {
    return this.__file;
  }

  getFilename(): string {
    return this.__filename;
  }

  exportJSON(): SerializedImageNode {
    return {
      type: 'image',
      file: this.__file,
      filename: this.__filename,
      version: 1,
    };
  }

  static importJSON(serializedNode: SerializedImageNode): ImageNode {
    const node = new ImageNode(
      serializedNode.file,
      serializedNode.filename,
    );
    return node;
  }
} 